import debug from 'debug';
import { getCenter } from 'ol/extent';
import { displayException, mapCRSFromConfig, parseCRSName } from 'sdi/app';
import { defaultInteraction } from 'sdi/map';
import 'sdi/polyfill';
import { defaultShape } from 'sdi/shape';
import { configure } from 'sdi/shape/functions';
import type { IShape } from 'sdi/shape/types';
import { AppConfigIO, EmbedProfileIO, getMessage, source } from 'sdi/source';
import App from './app';
import './locale';
import './shape';

const logger = debug('sdi:index');

const DEFAULT_ZOOM = 9;

const getProfileFromParams = () => {
    const loc = document.location;
    const params = new URL(loc.href).searchParams;
    return EmbedProfileIO.decode(params.get('profile')).getOrElse('simple');
};

export const main = (SDI: unknown) => {
    AppConfigIO.decode(SDI).fold(
        errors => {
            const textErrors = errors.map(e => getMessage(e.value, e.context));
            displayException(textErrors.join('\n'));
        },
        config => {
            const initialState: IShape = {
                'app/codename': 'embed',
                ...defaultShape(config),

                'app/layout': 'map',
                'app/current-layer': null,
                'app/selected-features': [],
                'app/current-feature': null,
                'app/profile': getProfileFromParams(),

                'data/alias': [],
                'data/map': null,
                'data/metadata': [],
                'data/layer': [],
                'data/layerinfo-list': [],

                'port/map/scale': {
                    count: 0,
                    unit: '',
                    width: 0,
                },

                'port/map/view': {
                    dirty: 'geo',
                    srs: parseCRSName(mapCRSFromConfig(config)),
                    center: getCenter(config.defaultExtent),
                    rotation: 0,
                    zoom: DEFAULT_ZOOM,
                    feature: null,
                    extent: null,
                },

                'port/map/interaction': defaultInteraction(),
                'port/map/gps-tracker-active': false,

                'data/baselayers': [],
            };

            try {
                const start = source<IShape>(['app/lang']);
                const store = start(initialState);
                configure(store);
                const app = App(store);
                logger('start rendering');
                app();
            } catch (err) {
                displayException(`${err}`);
            }
        },
    );
};

logger('loaded');
